import { EndpointPredefinedMessageModel } from "../schema";

export class EndpointPredefinedMessageContainer{
    endpoint_predefined_message: EndpointPredefinedMessageModel
}